<div class="qe-choices" [formGroup]="group">
  <div class="qe-choices__list" formArrayName="options">
    @for (option of options.controls; track option; let i = $index) {
      <div
        class="qe-choice"
        [class.qe-choice--correct]="option.controls.isCorrect.value"
        [formGroupName]="i">

        <!-- Marqueur de bonne réponse : radio (exclusif) ou case à cocher -->
        <div class="qe-choice__marker">
          @if (isExclusive) {
            <input
              class="form-check-input qe-choice__radio"
              type="radio"
              [attr.aria-label]="'QUESTION_EDITOR.MARK_AS_CORRECT' | translate"
              [checked]="option.controls.isCorrect.value"
              (change)="correctSelected.emit(i)" />
          } @else {
            <input
              class="form-check-input qe-choice__checkbox"
              type="checkbox"
              formControlName="isCorrect"
              [attr.aria-label]="'QUESTION_EDITOR.MARK_AS_CORRECT' | translate" />
          }
        </div>

        <span class="qe-choice__letter">{{ optionLetter(i) }}</span>

        <!-- Libellé de la réponse -->
        @if (isLocked) {
          <span class="qe-choice__locked">
            <i class="fa-solid fa-lock qe-choice__lock-icon"></i>
            {{ lockedLabelKey(i) | translate }}
          </span>
        } @else {
          <app-rich-field class="qe-choice__rich" [compact]="true">
            <input
              class="form-control qe-choice__input"
              type="text"
              formControlName="content"
              [placeholder]="'QUESTION_EDITOR.OPTION_PLACEHOLDER' | translate" />
          </app-rich-field>
        }

        <!-- Suppression -->
        @if (canRemove) {
          <button
            class="qe-choice__remove"
            type="button"
            [attr.aria-label]="'QUESTION_EDITOR.REMOVE_OPTION' | translate"
            [title]="'QUESTION_EDITOR.REMOVE_OPTION' | translate"
            (click)="removeOption.emit(i)">
            <i class="fa-solid fa-xmark"></i>
          </button>
        }
      </div>
    }
  </div>

  @if (canAdd) {
    <button class="qe-choices__add" type="button" (click)="addOption.emit()">
      <i class="fa-solid fa-plus"></i>
      {{ 'QUESTION_EDITOR.ADD_OPTION' | translate }}
    </button>
  }

  <p class="qe-choices__rule">
    <i class="fa-regular fa-circle-question"></i>
    @switch (mode) {
      @case ('single') {
        {{ 'QUESTION_EDITOR.RULE_SINGLE_CHOICE' | translate: { min: minOptions } }}
      }
      @case ('multiple') {
        {{ 'QUESTION_EDITOR.RULE_MULTIPLE_CHOICE' | translate: { min: minOptions } }}
      }
      @case ('true_false') {
        {{ 'QUESTION_EDITOR.RULE_TRUE_FALSE' | translate }}
      }
    }
  </p>
</div>
